<button
  nz-button
  [nzType]="buttonType"
  nzSize="small"
  nz-popover
  [nzPopoverTitle]="editTitle"
  [nzPopoverContent]="contentTemplate"
  nzPopoverTrigger="click"
  [(nzPopoverVisible)]="isVisible"
  [matTooltip]="editTitle"
>
  <span nz-icon style="font-size: 16px" class="material-symbols-rounded">edit</span>
  <ng-content></ng-content>
  <ng-template #contentTemplate>
    <div class="edit-area vertical-large">
      <textarea
        nz-input
        placeholder=""
        [ngModel]="content"
        (ngModelChange)="onContentChange($event)"
        [nzAutosize]="{ minRows: 3, maxRows: 6 }"
      ></textarea>

      <button nz-button nzType="primary" nzSize="default" (click)="onSaveClick()">Save</button>
    </div>
  </ng-template>
</button>
